import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {BehaviorSubject, interval, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import * as moment from "moment";
import {AppClockService} from "../../services/app.clock.service";

@Component({
  selector: 'app-clock',
  templateUrl: 'app.clock.component.html',
  styleUrls: ['app.clock.component.scss']
})
export class AppClockComponent implements OnInit, OnDestroy {
  @Input() position: string = 'footer';

  _onDestroy = new Subject<void>();
  _stopTimer = new Subject<void>();
  dateTimeString = new BehaviorSubject<string>(null);
  show = new BehaviorSubject<boolean>(false);

  style = '';

  constructor(private csvc: AppClockService) {
  }

  ngOnDestroy(): void {
    this.destroy();
    this._onDestroy.complete();
  }

  init() {
    this.show.next(true);
    interval(700).pipe(takeUntil(this._stopTimer)).subscribe(() => {
      let dt = moment();
      let str = '';
      if (this.style.includes('d')) {
        str += dt.format('DD.MM.YYYY');
      }
      if (this.style.includes('z')) {
        if (str != '') {
          str += ' ';
        }
        str += dt.format('HH:mm');
      }
      if (this.style.includes('kw')) {
        if (this.style.includes('d') && this.position == 'navbar') {
          str += '<br>';
        } else {
          str += ' ';
        }
        str += 'KW '+dt.isoWeek();
      }
      this.dateTimeString.next(str);
    });
  }

  destroy() {
    this.show.next(false);
    this._stopTimer.next();
  }

  ngOnInit(): void {
    this.csvc.style.pipe(takeUntil(this._onDestroy)).subscribe(style => {
      this.style = style;
    });
    this.csvc.position.pipe(takeUntil(this._onDestroy)).subscribe(pos => {
      if (this.position == pos) {
        this.init();
      } else  {
        this.destroy();
      }
    });
  }
}
